import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/shared/components/ui/button";
import { CardContainer } from "@/shared/components/CardContainer";
import { MobileHeader } from "@/shared/components/MobileHeader";
import { ResponsiveViewWrapper } from "@/shared/components/ResponsiveViewWrapper";
import { useAuth } from "../hooks/useAuth";
import { TenantSelector } from "./TenantSelector";

/** Recovery presentation only; the route guard owns all authorization decisions. */
export function AccessDenied() {
  const { activeTenant, logout } = useAuth();
  return (
    <ResponsiveViewWrapper aria-label="دسترسی محدود">
      <MobileHeader subtitle="دسترسی محدود" showBack />
      <div className="space-y-4 p-4 text-center">
        <CardContainer variant="soft" className="space-y-4 py-8">
          <ShieldAlert
            className="text-destructive mx-auto h-10 w-10"
            aria-hidden="true"
          />
          <h2 className="text-slate-dark text-base font-bold">
            به این صفحه دسترسی ندارید
          </h2>
          <p className="text-slate-muted text-sm">
            دسترسی شما در {activeTenant?.tenantName ?? "مدرسه انتخاب‌شده"} برای
            نمایش این صفحه کافی نیست. می‌توانید مدرسه را تغییر دهید یا با حساب
            دیگری وارد شوید.
          </p>
          <TenantSelector />
          <Button asChild variant="brand" size="touch" className="w-full">
            <Link to="/">بازگشت به صفحه اصلی</Link>
          </Button>
          <Button
            variant="outlineBrand"
            size="touch"
            onClick={logout}
            className="w-full"
          >
            ورود با حساب دیگر
          </Button>
        </CardContainer>
      </div>
    </ResponsiveViewWrapper>
  );
}
